import axios from '@/utils/axios';

export const GenerateAIStory = async (
  { 
    productSlug, 
    payload, 
  } 
  : 
  { 
    productSlug: string; 
    payload: 
    { 
      inputs: any;
      gender: string; 
      child_image: string;
    }; 
  }) => {
    const response = await axios.get(
      `${process.env.NEXT_PUBLIC_API_URL}/ai-story/product/${productSlug}`, 
      { 
        params: {
          // Pass ALL three parameters
          gender: payload.gender, 
          child_image: payload.child_image,
          inputs: payload.inputs,
        }, 
      }
    ); 
    return response.data; 
};

export const PollAIStoryJob = async (pollUrl: string) => {

  const response = await axios.get(pollUrl)

  return response.data;
};